import MyAppsControl from './MyAppsControl';
import MyAppsWidget from './MyAppsWidget';
import { Config } from './types';
import {
  defaultBorderData,
  defaultPaddingData,
  defaultMyappsSizeLocationData,
  cardThemeOptions,
} from 'builder/util/constants';

export default {
  type: 'Application',
  displayName: 'Applications ',
  icon: 'AppMenu',
  initialConfig: {
    ...defaultMyappsSizeLocationData,
    ...defaultPaddingData,
    ...defaultBorderData,
    enableRegister: false,
    enableAppEnvironment: false,
    appsEnvironmentList: '',
    appRegistration: {
      businessKey: '',
    },
    uniqueId: '123abc',
    lineColor: 'red',
    enableFullScreen: false,
    siteId: 123,
    pageId: 456,
    visible: true,
    font: 'OptumSans',
    cardTheme: cardThemeOptions.Light,
  },
  components: {
    render: MyAppsWidget,
    control: MyAppsControl,
  },
  copyable: false,
} as HorizonWidgetDefinition<Config>;
